import { styled } from "styled-components";

export const ChangeButton = styled.button`
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  height: 100%;
  width: 48%;
  font-size: 14px;
`;
